
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    GetSumTeamCommission({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MemberAgentCommission/GetSumTeamCommission',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetMemberAgentCommissionList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberAgentCommission/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
